<template>
  <TextEditor
    type="slide-title"
    class="slide-title-editor"
    :id="slideActive.id"
    @update="onUpdateSlideTitle"
    :value="valueHtml"
    :initialValue="initialValueHtml"
    :disabled="isPresentingOrBackstageOrShare"
    :hasBorder="!isPresentingOrBackstageOrShare && isDefaultContent"
    :isTextColourLight="isTextColourLight"
    :maxChars="maxChars"
    :isPresentingDefaultContent="isPresentingDefaultContent"
  />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import TextEditor from './TextEditor.vue'
import SlideApi from '@/api/slide'
import utils from '@/util'
import gaCategories from '@/constant/gaCategories'
import Socket from '@/socket'
import EventBus from '@/eventBus'
import constants from '@/constant'

export default {
  components: {
    TextEditor,
  },
  props: {
    maxChars: {
      type: Number,
      default: 300,
    },
  },
  computed: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
    }),
    defaultTitle() {
      let title = ''
      constants.defaultSlideTitles.forEach((item) => {
        if (this.slideActive.type === item.type) {
          title = item.defaultTitle
        }
      })

      return title
    },
    defaultHtmlContent() {
      const align = this.slideActive.textAlign || 'center'
      return `<p style="text-align: ${align}">${this.defaultTitle}</p>`
    },
    isPresentingOrBackstageOrShare() {
      return this.sharePresentation || this.isPresenting || this.isBackstage
    },
    isPresentingDefaultContent() {
      return this.isDefaultContent && this.isPresentingOrBackstageOrShare && this.slideActive.type !== 'leaderboard'
    },

    transformedTitle() {
      if (!this.slideActive.title) {
        return null
      }
      const align = this.slideActive.textAlign || 'center'
      return `<p style="text-align: ${align}">${this.slideActive.title}</p>`
    },
    titleHtml() {
      return this.slideActive.titleHTML || this.transformedTitle || this.defaultHtmlContent
    },
    initialValueHtml() {
      return this.defaultHtmlContent
    },
    valueHtml() {
      return this.titleHtml
    },
    isCorrectOrderSlideType() {
      return this.slideActive.type === 'pickAnswer' && this.slideActive.slideType === 'correctOrder'
    },
    isTextColourLight() {
      return this.slideActive.textColour === '#ffffff'
    },
    isDefaultContent() {
      return utils.extractContent(this.valueHtml, true) ===
        utils.extractContent(this.initialValueHtml, true)
    },
  },

  methods: {
    ...mapActions(['updateSlideActiveAction', 'updateSlideByIdAction', 'setSyncLoadingAction', 'addActionToHistory']),

    async onUpdateSlideTitle(type, props) {
      try {
        this.updateSlideByIdAction(props)
        this.setSyncLoadingAction(1)
        const payload = {
          presentationId: this.presentation.id,
          accessCode: this.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.isPresenting || this.isBackstage,
          ...props,
        }
        this.addHistoryUpdateTitleSlide(payload.title)

        EventBus.$emit(`update-right-column-for-${type}-${props.id}`, payload.title)
        await SlideApi.updateSlideById(props.id, payload)
        this.setSyncLoadingAction(2)
        this._handleTrackGAAfterUpdate()
      } catch (error) {
        this.setSyncLoadingAction(3)
      }
    },

    addHistoryUpdateTitleSlide(title) {
      if (title === this.slideActive.title) {
        return
      }
      this.addActionToHistory({
        type: 'UpdateTitleSlide',
        data: {
          idName: 'title-slide-edit',
          value: this.slideActive.title,
        },
        newData: {
          idName: 'title-slide-edit',
          value: title,
        },
        slideActiveId: this.slideActive.id,
        componentName: 'SlideTitleSettings',
      })
    },

    _handleTrackGAAfterUpdate() {
      const formalizedSlideType = `${this.slideActive.type} ${this.slideActive.slideType}`
      utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Edit slide title',
        'Canvas',
        formalizedSlideType,
        {
          slideId: this.slideActive.id,
        },
      )
    },
  },
}
</script>

<style>
.slide-title-editor {
  min-width: 150px;
  max-height: 270px;
}
</style>
